import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'
import numeral from 'numeral'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'job',
        render: item => {
          if (item && item.type) {
            let jobUrl = `/jobView/${item.id}/${item.type.replace('/', '-')}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Job Name',
        width: 200,
        dataIndex: 'name'
      },
      {
        title: 'Company',
        width: 200,
        dataIndex: 'company_name'
      },
      {
        title: 'Base Contract Total',
        dataIndex: 'base_contract_total_formatted'
      },
      {
        title: 'Net Changes',
        dataIndex: 'net_changes_formatted'
      },
      {
        title: 'Job Total',
        dataIndex: 'job_total_formatted'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Create Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { fullReport } = this.props

    let data = fullReport.map((item, index) => {
      item.created_date = moment(new Date(item.created_date)).format('YYYY-MM-DD')
      const job_total = (item.base_contract_total || 0) + (item.net_changes || 0)
      item.job_total_formatted = numeral(job_total).format('$0,0.00')
      item.base_contract_total_formatted = numeral(item.base_contract_total).format('$0,0.00')
      item.net_changes_formatted = numeral(item.net_changes).format('$0,0.00')
      item.job = {
        id: item.id,
        type: item.type
      }
      return item
    })

    return data
  }

  getBaseContractTotal = () => {
    const { fullReport } = this.props
    var sum = 0
    fullReport.forEach(item => {
      sum += item.base_contract_total
    })
    return sum
  }

  getNetChangesTotal = () => {
    const { fullReport } = this.props
    var sum = 0
    fullReport.forEach(item => {
      sum += item.net_changes
    })
    return sum
  }

  getJobTotal = () => {
    const { fullReport } = this.props
    var sum = 0
    fullReport.forEach(item => {
      let job_total = (item.base_contract_total || 0) + (item.net_changes || 0)
      sum += job_total
    })
    return sum
  }

  getTotals() {
    const base_total = this.getBaseContractTotal()
    const job_total = this.getJobTotal()
    const net_total = this.getNetChangesTotal()
    return {
      net_changes: numeral(net_total).format('$0,0.00'),
      base_contract_total: numeral(base_total).format('$0,0.00'),
      job_total: numeral(job_total).format('$0,0.00')
    }
  }

  tableComponents = (totals, key = 'tableKey') => ({ className, style, children }) => (
    <table className={className} style={style} key={key}>
      {children}
      <tfoot>
        <tr>
          <td className="padding8">Totals</td>
          <td />
          <td />
          <td className="padding8">{totals.base_contract_total}</td>
          <td className="padding8">{totals.net_changes}</td>
          <td className="padding8">{totals.job_total}</td>
          <td />
          <td />
        </tr>
      </tfoot>
    </table>
  )

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              components={{ table: this.tableComponents(this.getTotals()) }}
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/financial/active-job-contracts-report/ListItems.js